var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('div',{staticClass:"boxi text-center"},[_c('div',{staticClass:"textinBox"},[_c('h4',[_vm._v("Package Offers - Coming Soon")])])])])
}]

export { render, staticRenderFns }